export const SET_SELECTION = 'set_selection';
export const SET_NODE = 'set_node';
export const INSERT_TEXT = 'insert_text';
export const TEST = 'TEST';
export const MOVE_NODE = 'move_node';
export const ADD_MARK = 'add_mark';
export const REMOVE_MARK = 'remove_mark';
